export const STATUS_OPTIONS = [
  { value: "ALL", label: "All statuses" },
  { value: "ACTIVE", label: "Active" },
  { value: "PENDING", label: "Pending" },
  { value: "INACTIVE", label: "Inactive" },
  { value: "SUSPENDED", label: "Suspended" },
];

export const EMPTY_FORM = {
  firstName: "",
  lastName: "",
  username: "",
  email: "",
  phone: "",
  gender: "",
  status: "ACTIVE",
  password: "",
};

export const cleanValue = (value) => {
  if (value === null || value === undefined) return "";
  const normalized = String(value).trim();
  return normalized === "None" ? "" : normalized;
};

export const getDisplayName = (user = {}) =>
  `${cleanValue(user?.firstName)} ${cleanValue(user?.lastName)}`.trim() ||
  cleanValue(user?.fullName) ||
  cleanValue(user?.username) ||
  cleanValue(user?.email) ||
  "Unknown user";

export const getInitials = (user = {}) => {
  const first = cleanValue(user?.firstName);
  const last = cleanValue(user?.lastName);
  if (first || last) return `${first[0] || ""}${last[0] || ""}`.toUpperCase();
  const name = getDisplayName(user);
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0] || "")
    .join("")
    .toUpperCase();
};

export const formatDate = (value) => {
  if (!value) return "Unknown";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString();
};

export const getStatusColor = (status = "") => {
  const normalized = String(status || "").toUpperCase();
  if (normalized === "ACTIVE") return "green";
  if (normalized === "PENDING") return "gold";
  if (normalized === "SUSPENDED") return "volcano";
  if (normalized === "INACTIVE") return "default";
  return "blue";
};

export const computeUserStats = (users = []) => {
  const counts = {};
  users.forEach((user) => {
    const key = String(user?.status || "UNKNOWN").toUpperCase();
    counts[key] = (counts[key] || 0) + 1;
  });
  return counts;
};
